export enum CourseOrderBy {
  STUDY_SUBJECT_NAME = 'studySubjectName',
  START_DATE = 'startDate',
  SCHOOL_NAME = 'schoolName',
  STATUS = 'status',
}
